import { Link } from 'react-router-dom';

function countryName(original) {
  return (
    <Link to={`/countries/edit/${original?.id}`}>
      {original?.countryName || ''}
    </Link>
  );
}

function countryCode(original) {
  return original?.countryCode || '';
}

function countryCodeAlpha3(original) {
  return original?.countryCodeAlpha3 || '';
}

function currencyCode(original) {
  return original?.currencyCode || '';
}

function isActive(original) {
  return original?.isActive ? 'Active' : 'In-Active';
}

export { countryName, countryCode, countryCodeAlpha3, currencyCode, isActive };
